import React from 'react';
import RouteStore from '../stores/RouteStore';
import { WebContentResult } from './SearchInterfaces';
import WebSearchResult from './WebSearchResult';

export interface SearchResultProps {
  result: WebContentResult;
  onClick: (item: any) => void;
  contentClientTypeFilter: string;
  translate: (key: string) => string;
  routeStore?: RouteStore;
}

const SearchResult = (props: SearchResultProps) => {
  return <WebSearchResult {...props} />;
};

export default SearchResult;
